import { render } from "./ColisListe.vue?vue&type=template&id=49698963&scoped=true&ts=true"
import script from "./ColisListe.vue?vue&type=script&lang=ts"
export * from "./ColisListe.vue?vue&type=script&lang=ts"

import "./ColisListe.vue?vue&type=style&index=0&id=49698963&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49698963"]])

export default __exports__